var constant = require('./constant');

var Data = function() {
    var CAT_ORDER = ['exterior', 'interior', 'seating', 'dashboard', 'cargo', 'color'];
    var pageValues = window.EDM.PageValues;
    var MINIMAL_PARAMS = '?count=0&photoSize={photoSize}';
    var pv = pageValues.vehicle;
    var imageIndexes;
    var REST_URL = '/api-pg/mobile-rest-media/pp-categorized/v2/media/{make}/{model}/{year}/';
    var STD_PARAMS = '?submodel={submodel}&offset={index}&count=5&photoSize={photoSize}&filterBy=all&excludeOtherSubmodels=false';

    function getPhotoSize() {
        var yearNum = parseInt(pv.modelYear.year, 10);
        return pv.publicationState === 'used' && yearNum <= 2012 ? constant.USED_PHOTO_SIZE : constant.DEFAULT_PHOTO_SIZE;
    }

    function getSubmodel() {
        return pageValues.attributes && pageValues.attributes.submodel ? pv.subModel.identifier : '';
    }

    return {
        CATEGORY_HOME: 'home',
        getRestUrl: function(options) {
            var url = REST_URL + STD_PARAMS;
            var offset = 0;
            if (options.imageType) {
                offset = imageIndexes[options.imageType];
            }
            if (options.index) {
                offset = options.index;
            }
            if (offset < 0) { offset = 0; }
            if (options.minimal) {
                url = REST_URL + MINIMAL_PARAMS;
            }
            url = url
                .replace('{make}', pv.make.niceName)
                .replace('{model}', pv.model.niceName)
                .replace('{year}', pv.modelYear.year)
                .replace('{photoSize}', getPhotoSize())
                .replace('{submodel}', getSubmodel())
                .replace('{index}', offset);
            return url;
        },
        getSomeData: function(url, cb) {
            return $.get(url, cb);
        },
        getIndexOfCategory: function(imageType) {
            return imageIndexes[imageType];
        },
        getMaxIndex: function() {
            return imageIndexes;
        },
        calculateIndexes: function(data) {
            var index = 0;
            var thing = {};
            CAT_ORDER.forEach(function(cat) {
                thing[cat] = index;
                index = index + data.categoryCounts[cat];
            });
            imageIndexes = thing;
        }
    };
};

module.exports = new Data();



//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel-data.js
// module id = 182
// module chunks = 0 1 27